import { Framework } from '@/framework/instance';
import { SizeUnitType } from '@/utils/unit-kit';
import { IEditMessage } from '../../types';
import { OperateType } from '../../types/operate';
import { Collaborators } from '../collaborators';
import { Room } from '../room';

/**
 * 舞台单位
 */
export class StageUnit extends Framework {
    private eventName = 'sync-stage-unit';

    constructor(
        identity: string,
        private room: Room,
        private collaborators: Collaborators,
    ) {
        super(identity);
        this.room.onMessage(OperateType.SyncUnit, this.onReceiveUnit.bind(this));
    }

    send(unit: SizeUnitType) {
        this.room.sendToAll(OperateType.SyncUnit, [unit]);
    }

    private onReceiveUnit({ data }: IEditMessage<SizeUnitType[]>) {
        const [unit] = data;
        this.framework.events.emit(this.eventName, unit);
    }

    onReceive(fn: (unit: SizeUnitType) => void) {
        return this.framework.events.on(this.eventName, fn);
    }
}
